module.exports = __webpack_public_path__ + "Roboto-Black.woff?8f766bb9720fe9b3fe48362d3dc31acf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/Black/Roboto-Black.woff?v=2.137
// module id = 670
// module chunks = 7